import React from 'react';
import { connect } from 'react-redux';
import { Checkbox } from 'react-bootstrap';
import { actions, Errors, Control } from 'react-redux-form';

class CommunicationPreferences extends React.Component {
  componentDidMount() {
    this.setErrors();
  }

  componentDidUpdate() {
    this.setErrors();
  }

  componentWillUnmount() {
    const { dispatch, model } = this.props;
    dispatch(actions.setErrors(`${model}.comms_mobile`, {
      required: false
    }));
  }

  setErrors = () => {
    const {
      dispatch, model, commsEmail, commsMobile, marketing
    } = this.props;
    dispatch(actions.setErrors(`${model}.comms_mobile`, {
      required: (!commsEmail && !commsMobile) && marketing === 'true'
    }));
  };

  render() {
    const { model } = this.props;
    return (
      <div>
        <label>How would you like us to contact you?</label>
        <br/>

        <Control.checkbox
          model={`${model}.comms_email`}
          component={Checkbox}
        >
          Email
        </Control.checkbox>
        <Control.checkbox
          model={`${model}.comms_mobile`}
          component={Checkbox}
        >
          Mobile
        </Control.checkbox>
        <Errors
          className="errors"
          model={`${model}.comms_mobile`}
          show
          messages={{
            required: 'You must select at least one communication preference.'
          }}
        />

      </div>
    );
  }
}

export default connect()(CommunicationPreferences);



// WEBPACK FOOTER //
// ./src/components/common/form/user/communication-preferences.jsx